import { render } from "./AspirantePage.vue?vue&type=template&id=0dc3cbda"
import script from "./AspirantePage.vue?vue&type=script&lang=js"
export * from "./AspirantePage.vue?vue&type=script&lang=js"

import "./AspirantePage.vue?vue&type=style&index=0&id=0dc3cbda&lang=scss"

import exportComponent from "C:\\Users\\elkinc\\Desktop\\ANSV\\Licencias\\AppExamenes\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__